import GlobalSearch from '../../../../components/stories/organisms/top-navigation/components/global-search/index.jsx'
import { useCallback, useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import CustomPinsTab from './custom-pins-list.jsx'
import CustomTasksTab from './custom-tasks-list.jsx'
import CustomPlansTab from './custom-plans-list.jsx'
import { useGlobalSearchGetPinsQuery } from '../../../../react-query/global-search/query/use-global-search-get-pins-query.jsx'
import { useGlobalSearchGetTasksQuery } from '../../../../react-query/global-search/query/use-global-search-get-tasks-query.jsx'
import { useGetPlansInfinityQuery } from '../../../../react-query/plan/queries/use-get-plans-infinity-query.jsx'
import { plansApiTypeOptions } from '../../../../react-query/plan/queries/constants.js'
import { useCreateFilterQuery } from '../../../../react-query/filters/query/use-create-filter-query.jsx'
import { pinsSearchFilter, tasksSearchFilter } from './constants.js'
import { useHistory } from 'react-router-dom'
import { makeSelectProjectDetails } from '../../../ProjectSettings/selectors.js'

export const SearchBar = () => {
  const history = useHistory()
  const [isOpen, setIsOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [counter, setCounter] = useState({
    pins: 0,
    tasks: 0,
    plans: 0
  })

  const projectId = useSelector(makeSelectProjectDetails())?.id

  const { data: pinFilter } = useCreateFilterQuery(
    pinsSearchFilter(projectId, search),
    search,
    'Pins',
    { enabled: !!search }
  )

  const { data: taskFilter } = useCreateFilterQuery(
    tasksSearchFilter(projectId, search),
    search,
    'Tasks',
    { enabled: !!search }
  )

  const tasksQuery = useGlobalSearchGetTasksQuery(projectId, taskFilter?.id)
  const pinsQuery = useGlobalSearchGetPinsQuery(projectId, pinFilter?.id)
  const plansQuery = useGetPlansInfinityQuery(
    projectId,
    plansApiTypeOptions.PROJECTS,
    search,
    'LastActivity',
    'Plans',
    15,
    'Active',
    'DESC'
  )

  const handleSetCounter = useCallback(() => {
    setCounter({
      pins: pinsQuery.isLoading
        ? undefined
        : pinsQuery.data?.pages[0]?.totalElements || 0,
      tasks: tasksQuery.isLoading
        ? undefined
        : tasksQuery.data?.pages[0]?.totalElements || 0,
      plans: plansQuery.isLoading
        ? undefined
        : plansQuery.data?.pages[0]?.totalElements || 0
    })
  }, [
    pinsQuery.data?.pages,
    pinsQuery.isLoading,
    tasksQuery.data?.pages,
    tasksQuery.isLoading,
    plansQuery.data?.pages,
    plansQuery.isLoading
  ])

  useEffect(() => {
    handleSetCounter()
  }, [handleSetCounter])

  const handleClose = () => setIsOpen(false)

  const handleNavigatePin = (pin) => {
    handleClose()
    history.push(
      `/project/${projectId}/${pin.planReference.planId}/plan/${pin.id}/media`
    )
  }

  const handleNavigateTask = (task) => {
    handleClose()
    history.push(
      `/project/${projectId}/${task.planId}/plan/${task.issueId}/media/task/task-details/${task.id}`
    )
  }

  const handleNavigatePlan = (plan) => {
    handleClose()
    history.push(`/project/${projectId}/${plan.id}/plan`)
  }

  return (
    <>
      <GlobalSearch
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        pinsListComponent={
          <CustomPinsTab
            search={search}
            handleNavigatePin={handleNavigatePin}
            pinsQuery={pinsQuery}
          />
        }
        tasksListComponent={
          <CustomTasksTab
            search={search}
            handleNavigateTask={handleNavigateTask}
            tasksQuery={tasksQuery}
          />
        }
        plansListComponent={
          <CustomPlansTab
            search={search}
            handleNavigatePlan={handleNavigatePlan}
            plansQuery={plansQuery}
          />
        }
        search={search}
        setSearch={setSearch}
        counter={counter}
        disabled={!projectId}
      />
    </>
  )
}
